/*
 * Trafford product card hover.
 * Recreates the live "Product card [HOVER]": the product image scales to 1.05 on hover
 * (back on leave), smoothed with GSAP. Applies to every .trafford-card (collection grid,
 * sliders, future product lists). Loaded site-wide. No-op without GSAP or with reduced motion.
 */
(function () {
  function init(root) {
    if (!window.gsap) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    (root || document).querySelectorAll('.trafford-card').forEach(function (card) {
      if (card.dataset.tHoverInit === '1') return;
      var img = card.querySelector('.trafford-card__img');
      if (!img) return;
      card.addEventListener('mouseenter', function () {
        window.gsap.to(img, { scale: 1.05, duration: 0.4, ease: 'power2.out', overwrite: true });
      });
      card.addEventListener('mouseleave', function () {
        window.gsap.to(img, { scale: 1, duration: 0.3, ease: 'power2.out', overwrite: true });
      });
      card.dataset.tHoverInit = '1';
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
